/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_DyedInputs */

const en_attribute_dyed = /** @type {(inputs: Attribute_DyedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dyed`)
};

/**
* | output |
* | --- |
* | "Dyed" |
*
* @param {Attribute_DyedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_dyed = /** @type {((inputs?: Attribute_DyedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_DyedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_dyed(inputs)
});